export default __webpack_public_path__ + "static/cat2-tutor-screen-c9bd357ca69cff0863644014ab509b9c.png";